import { ReactElement, useMemo, memo } from 'react';
import { get } from 'lodash';

import { ActivatedChipProps, ActivatedChipTypeMapping } from './types';
import { ActivatedChipRoot } from './styles';

const defaultVariantMapping: ActivatedChipTypeMapping = {
  active: {
    label: 'Activo',
    color: 'success',
  },
  inactive: {
    label: 'Inactivo',
    color: 'tertiary',
  },
};

const ActivatedChip = ({
  type = 'active',
  typeMapping = defaultVariantMapping,
  size = 'medium',
  variant = 'outlined',
  sx,
}: ActivatedChipProps): ReactElement => {
  const currentTypeData = useMemo(
    () => get(typeMapping as ActivatedChipTypeMapping, type),
    [typeMapping, type],
  );

  return (
    <ActivatedChipRoot
      variant={variant}
      label={currentTypeData.label}
      color={currentTypeData.color}
      size={size}
      sx={sx}
    />
  );
};

export default memo(ActivatedChip);
